module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.a57f481a.eot";